import React, { useState, useEffect } from "react";
import "./ProductionAnalytics.css"
import {
    Grid,
    Container,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    TableHead,
    Modal,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { images } from "../../config/images";
import { Button } from "../../components/Button/button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import SearchIcon from "@mui/icons-material/Search";
import Loader from "../../components/Loader/Loader";
import { getPlants, getProducts, getSizes } from "../Dashboard/services";
import { getExtruder } from "../Packing/service";
import { Link } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StaticDateRangePicker } from "@mui/x-date-pickers-pro";
import BasicRangeShortcuts from "../../components/DatePicker/DatePicker";
import ProductionChart from "./ProductionChart";
import { userFootFallTracking } from "../FootFallReport/services";

const ProductionAnalytics = () => {

    const navigate = useNavigate();

    const [selectedPlants, setSelectedPlants] = useState();
    const [selectedProducts, setSelectedProducts] = useState();
    const [selectedExtruder, setSelectedExtruder] = useState();
    const [selectedPlantId, setselectedPlantId] = useState();
    const [selectedProductId, setselectedProductId] = useState();
    const [selectedLineId, setSelectedLineId] = useState();
    const [selectedExtruderId, setSelectedExtruderId] = useState();
    const [datePickerOpen, setDatePickerOpen] = useState(false); // For date picker visibility
    const [dateRange, setDateRange] = useState([null, null]); // For selected date range
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [productionData, setProductionData] = useState([]);
    const [productionData1, setProductionData1] = useState([]);
    const [productionData2, setProductionData2] = useState([]);
    const [productionData3, setProductionData3] = useState([]);
    const [productionData4, setProductionData4] = useState([]);
    const [productionData5, setProductionData5] = useState([]);
    const [targetData, setTargetData] = useState({
        class_00: "",
        class_0: "",
        class_1: "",
        class_2: "",
        class_3: "",
        class_4: "",
    });

    // asynchronous function to fetch production data API
    const getData = async () => {
        try {
            const resp = await getPlants();
            setSelectedPlants(resp.data.payload);
            setselectedPlantId(resp.data.payload[0].id)
            const resp1 = await getProducts(resp.data.payload[0].id);
            setSelectedProducts(resp1.data.payload);
            setselectedProductId(resp1.data.payload[0].id);
            const resp2 = await getExtruder(resp.data.payload[0].id);
            setSelectedExtruder(resp2.data.payload);
            setSelectedExtruderId(resp2.data.payload[0].id);
        } catch (error) {
            console.log(error);
        }
    };

    // useEffect hook to fetch data when component mounts
    useEffect(() => {
        getData();
        return () => { };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const resp1 = await getProducts(selectedPlantId);
                if (resp1.data.success == true) {
                    setSelectedProducts(resp1.data.payload);
                    setselectedProductId(resp1.data.payload[0]?.id);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setSelectedProducts([]);
                setselectedProductId("");

            }
            try {
                const resp2 = await getExtruder(selectedPlantId);
                if (resp2.data.success == true) {
                    setSelectedExtruder(resp2.data.payload);
                    setSelectedExtruderId(resp2.data.payload[0]?.id);
                }

            } catch (error) {
                console.error("Error fetching data:", error);
                setSelectedExtruder([]);
                setSelectedExtruderId("");
            }
        };

        if (selectedPlantId) {
            fetchData();
        }
    }, [selectedPlantId]);


      useEffect(() => {
        let intervalId = null;
    
        const callUserFootFallTracking = () => {
          const moduleList = JSON.parse(localStorage.getItem("moduleList"));
          if (moduleList) {
            const module = moduleList.find((m) => m.name === "Production Analytics");
            if (module) {
              const params = { module_id: module.id };
              try {
                userFootFallTracking(params);
              } catch (error) {
                console.error("Error calling userFootFallTracking:", error);
              }
            }
          }
        };
    
        const startTracking = () => {
          if (!intervalId) {
            console.log("▶️ Start API interval");
            callUserFootFallTracking(); // call immediately
            intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000);
          }
        };
    
        const stopTracking = () => {
          if (intervalId) {
            console.log("⏹ Stop API interval");
            clearInterval(intervalId);
            intervalId = null;
          }
        };
    
        const handleVisibilityChange = () => {
          if (document.hidden) {
            stopTracking(); // stop when tab hidden/minimized
          } else {
            startTracking(); // resume when tab active
          }
        };
    
        // Setup listener
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        // Start tracking immediately if tab is visible
        if (!document.hidden) {
          startTracking();
        }
    
        return () => {
          stopTracking();
          document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
      }, []);

    const initialTableData = {
        parameters: ["Target", "Produced", "Accepted", "Rejected", "Yield"],
        classes: ["1/2'", "3/4'", "1'", "1 1/4'", "1 1/2'", "2'", "2 1/2'", "3'"],
        values: {
            Target: [8000, 8000, 8000, 8000, 8000, 8000, 8000, 8000],
            Produced: [790, 790, 3534, 4200, 6717, 4500, 3889, 3889],
            Accepted: [326, 326, 1588, 4000, 3638, 4000, 2132, 2132],
            Rejected: [790, 790, 3534, 200, 3079, 500, 1757, 1757],
            Yield: ["41%", "41%", "45%", "55%", "54%", "46%", "55%", "55%"],
        },
    };

    const [tableData, setTableData] = useState(initialTableData);

    const handleTargetChange = (index, value) => {
        // Update the target values in state
        const updatedTarget = [...tableData.values.Target];
        updatedTarget[index] = value;

        setTableData((prev) => ({
            ...prev,
            values: {
                ...prev.values,
                Target: updatedTarget,
            },
        }));
    };

    return (
        <>
            <div className="containerWrap">
                <Container maxWidth="xxl">
                    <div className="packingHeader-wrap">
                        <div className="packingTitle-wrap">
                            <KeyboardBackspaceIcon
                                onClick={() => navigate("/dashboard")}
                                className="backArrow"
                            />
                            <Typography
                                variant="h5"
                                className="packingTitle"
                                gutterBottom
                                onClick={() => navigate("/dashboard")}
                            >
                                Production Analytics
                            </Typography>
                        </div>
                        <div className="dispatchSummary-print-section">
                            <Box className="select-div" width="180px">
                                <select
                                    className="select-form"
                                    id="selectedClass"
                                    value={selectedExtruderId}
                                    onChange={(event) =>
                                        setSelectedExtruderId(event.target.value)
                                    }
                                    required
                                >
                                    <option value="" disabled>
                                        Select Extruder
                                    </option>

                                    {selectedExtruder ? (
                                        selectedExtruder.map((event) => (
                                            <option value={event.id}>{event.name}</option>
                                        ))
                                    ) : (
                                        <option disabled>{"No Data Found"}</option>
                                    )}
                                </select>
                            </Box>
                            <Box className="select-div" width="153px">
                                <select
                                    className="select-form"
                                    id="selectedClass"
                                    // defaultValue="all"
                                    value={selectedLineId}
                                    onChange={(event) =>
                                        setSelectedLineId(event.target.value)
                                    }
                                    required
                                >
                                    <option value="1"> Line 01 </option>
                                    <option value="2"> Line 02 </option>

                                </select>
                            </Box>
                            <Box className="select-div" width="180px">
                                <select
                                    className="select-form"
                                    id="selectedClass"
                                    // defaultValue="all"
                                    value={selectedPlantId}
                                    onChange={(event) =>
                                        setselectedPlantId(event.target.value)
                                    }
                                    required
                                >
                                    <option value="all"> All </option>
                                    {selectedPlants ? (
                                        selectedPlants.map((event) => (
                                            <option value={event.id}>{event.name}</option>
                                        ))
                                    ) : (
                                        <option>{"No Data Found"}</option>
                                    )}
                                </select>
                            </Box>
                            <Box className="select-div" width="180px">
                                <select
                                    className="select-form"
                                    id="selectedClass"
                                    // defaultValue="all"
                                    value={selectedProductId}
                                    onChange={(event) =>
                                        setSelectedProducts(event.target.value)
                                    }
                                    required
                                >
                                    <option value="" disabled>
                                        Select Product
                                    </option>
                                    {selectedProducts ? (
                                        selectedProducts.map((event) => (
                                            <option value={event.id}>{event.product_name}</option>
                                        ))
                                    ) : (
                                        <option>{"No Data Found"}</option>
                                    )}
                                </select>
                            </Box>
                            <Box className="icon-div"
                                onClick={() => setDatePickerOpen(!datePickerOpen)} // Open date picker
                                style={{ cursor: "pointer" }}>
                                <img src={images.datePickerIcon} />
                            </Box>
                            {datePickerOpen == true &&
                                <BasicRangeShortcuts />
                            }

                            <Box className="icon-div">
                                <img src={images.pdfDownloadIcon} /></Box>
                        </div>
                    </div>

                    <div className="production-qty">
                        {/* <ProductionChart
                            productionData={productionData}
                            productionData1={productionData1}
                            productionData2={productionData2}
                            productionData3={productionData3}
                            productionData4={productionData4}
                            productionData5={productionData5}
                            startDate={startDate}
                            endDate={endDate}
                            // targetData={targetData}
                        /> */}
                        <ProductionChart
                            classes={tableData.classes}
                            productionData={{
                                produce: tableData.values.Produced[0],
                                passed: tableData.values.Accepted[0],
                                rejected: tableData.values.Rejected[0],
                            }}
                            productionData1={{
                                produce: tableData.values.Produced[1],
                                passed: tableData.values.Accepted[1],
                                rejected: tableData.values.Rejected[1],
                            }}
                            productionData2={{
                                produce: tableData.values.Produced[2],
                                passed: tableData.values.Accepted[2],
                                rejected: tableData.values.Rejected[2],
                            }}
                            productionData3={{
                                produce: tableData.values.Produced[3],
                                passed: tableData.values.Accepted[3],
                                rejected: tableData.values.Rejected[3],
                            }}
                            productionData4={{
                                produce: tableData.values.Produced[4],
                                passed: tableData.values.Accepted[4],
                                rejected: tableData.values.Rejected[4],
                            }}
                            productionData5={{
                                produce: tableData.values.Produced[5],
                                passed: tableData.values.Accepted[5],
                                rejected: tableData.values.Rejected[5],
                            }}
                            productionData6={{
                                produce: tableData.values.Produced[6],
                                passed: tableData.values.Accepted[6],
                                rejected: tableData.values.Rejected[6],
                            }}
                            productionData7={{
                                produce: tableData.values.Produced[7],
                                passed: tableData.values.Accepted[7],
                                rejected: tableData.values.Rejected[7],
                            }}
                            targetData={{
                                class_00: tableData.values.Target[0],
                                class_0: tableData.values.Target[1],
                                class_1: tableData.values.Target[2],
                                class_2: tableData.values.Target[3],
                                class_3: tableData.values.Target[4],
                                class_4: tableData.values.Target[5],
                            }}
                        />
                    </div>
                    <div className="table-responsive production-table">
                        <Table aria-label="Analytics">
                            <TableHead>
                                <TableRow className="parameter-row">
                                    <TableCell className="parameter-row-cell">Parameters</TableCell>
                                    {tableData.classes.map((className, index) => (
                                        <TableCell key={index} className="parameter-row-cell">{className}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody className="production-tablebody">
                                {Object.keys(tableData.values).map((parameter, paramIndex) => (
                                    <TableRow key={paramIndex}>
                                        <TableCell>
                                            <div
                                                style={{ color: "black", marginRight: "25px" }}
                                                className="d-flex align-items-center"
                                            >
                                                {/* Add colored indicators dynamically */}
                                                <span
                                                    className={`${parameter.toLowerCase()}-btn m-1`}
                                                    style={{
                                                        display: "flex",
                                                        width: "16px",
                                                        height: "16px",
                                                        backgroundColor:
                                                            parameter === "Target"
                                                                ? "#f6e163"
                                                                : parameter === "Produced"
                                                                    ? "#1c407b"
                                                                    : parameter === "Accepted"
                                                                        ? "#00ab66"
                                                                        : parameter === "Rejected"
                                                                            ? "#e31e24"
                                                                            : "none",
                                                        borderRadius: "50%",
                                                    }}
                                                ></span>
                                                {parameter}
                                            </div>
                                        </TableCell>
                                        {tableData.values[parameter].map((value, valueIndex) => (
                                            <TableCell key={valueIndex}>
                                                {parameter === "Target" ? (
                                                    <input
                                                        type="number"
                                                        value={value}
                                                        onChange={(e) => handleTargetChange(valueIndex, e.target.value)}
                                                        size="small"
                                                        className="input-number"
                                                        inputProps={{ style: { textAlign: "center" } }} // Center align the text
                                                    />
                                                ) : (
                                                    value
                                                )}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                                {/* <TableCell>
                                            <div
                                                style={{ color: "black", marginRight: "25px" }}
                                                className="d-flex align-items-center"
                                            >
                                                <span className="target-btn m-1"></span>Target
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <input
                                                type="number"
                                                className="input-number"
                                                name="class_00"
                                            // onChange={handelTargetData}
                                            // value={targetData.class_00}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <input
                                                type="number"
                                                className="input-number"
                                                name="class_0"
                                            // onChange={handelTargetData}
                                            // value={targetData.class_0}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <input
                                                type="number"
                                                className="input-number"
                                                name="class_1"
                                            // onChange={handelTargetData}
                                            // value={targetData.class_1}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <input
                                                type="number"
                                                className="input-number"
                                                name="class_2"
                                            // onChange={handelTargetData}
                                            // value={targetData.class_2}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <input
                                                type="number"
                                                className="input-number"
                                                name="class_3"
                                            // onChange={handelTargetData}
                                            // value={targetData.class_3}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <input
                                                type="number"
                                                className="input-number"
                                                name="class_4"
                                            // onChange={handelTargetData}
                                            // value={targetData.class_4}
                                            />
                                        </TableCell> */}
                                {/* </TableRow>  */}
                                {/* <TableRow>
                                    <TableCell>
                                        <div
                                            style={{ color: "black", marginRight: "25px" }}
                                            className="d-flex align-items-center"
                                        >
                                            <span className="produced-btn m-1"></span>Produced
                                        </div>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <div
                                            style={{ color: "black", marginRight: "25px" }}
                                            className="d-flex align-items-center"
                                        >
                                            <span className="acceptedparam-btn m-1"></span>Accepted
                                        </div>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <div
                                            style={{ color: "black", marginRight: "25px" }}
                                            className="d-flex align-items-center"
                                        >
                                            <span className="rejectedparam-btn m-1"></span>Rejected
                                        </div>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <div
                                            style={{ color: "black", marginRight: "25px" }}
                                            className="d-flex align-items-center"
                                        >
                                            <span className="Yieldbtn m-1"></span>Yield
                                        </div>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow> */}


                            </TableBody>
                        </Table>

                    </div>
                    <div className="d-flex justify-content-end">
                        <Link
                            to="/production-analytics/production"
                            style={{ color: "#ffff" }}
                            className="production-button"
                        >
                            Production
                        </Link>
                    </div>
                </Container >
            </div >


            {/* Date Picker Modal */}
            {/* <Modal open={datePickerOpen} onClose={() => setDatePickerOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <StaticDateRangePicker
                            value={dateRange}
                            onChange={(newValue) => setDateRange(newValue)}
                            slotProps={{
                                actionBar: { actions: ["clear", "cancel"] },
                            }}
                        />
                    </LocalizationProvider>
                    <Box mt={2}>
                        <Button
                            variant="contained"
                            onClick={() => setDatePickerOpen(false)}
                        >
                            Apply
                        </Button>
                    </Box>
                </Box>
            </Modal> */}


        </>
    )
}
export default ProductionAnalytics;
